import { useCallback } from 'react';

import { usePushBack } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

export const usePushBackToVisit = (visitId: number): VoidFunction => {
   const push = usePushBack();

   return useCallback(
      () =>
         push(
            visitPaths.getVisitInterviewPath({
               params: {
                  visitId: visitId,
               },
            })
         ),
      [push, visitId]
   );
};
